import Vue from "vue";
import symbols from "../../utils/symbols";
const vm = new Vue();

const initial_state = {};
symbols
  .filter((item) => item != "ANY")
  .forEach((symbol) => {
    initial_state[symbol] = {
      last_price: null,
      ask_price: null,
      bid_price: null,
    };
  });

export default {
  namespaced: true,

  state: {
    marketData: { ...initial_state },
  },

  getters: {
    getMarketdata(state) {
      let obj = {};
      Object.keys(state.marketData).forEach((key) => {
        if (state.marketData[key] != null) {
          obj[key] = state.marketData[key].last_price;
        }
      });
      // console.log("state.marketData.....", obj);
      return obj;
    },
    // getSymbolPrice:
    //   (state) =>
    //   (symbol, prop = "last_price") =>
    //     state.marketData[symbol][prop],
    getSymbolPrice:
      (state) =>
      (symbol, prop = "last_price") => {
        // console.log("%c------------", "color:#007FFF;");
        // console.log(
        //   "%c@[BEST]",
        //   "padding:3px;font-weight:bold;background-color:#007FFF;color:white;",
        //   symbol,
        //   state.marketData[symbol][prop]
        // );
        // console.log(symbol, state.marketData[symbol][prop]);
        return state.marketData[symbol][prop];
      },
  },

  mutations: {
    SET_MARKETDATA(state, payload) {
      // console.log("<<<<<<state, payload>>>>>>", state, payload);
      const { symbol, last_price, bid_price, ask_price } = payload;
      if (last_price) {
        vm.$set(state.marketData, symbol, {
          last_price: Number(last_price),
          bid_price: Number(bid_price),
          ask_price: Number(ask_price),
        });
      }
    },
    CLEAR_MARKET_DATA(state) {
      state.marketData = { ...initial_state };
    },
  },

  actions: {
    setMarketdata({ commit }, payload) {
      // let { symbol, last_price } = payload;
      // console.log(payload);
      commit("SET_MARKETDATA", payload);
    },
    clearMarketdata({ commit }) {
      commit("CLEAR_MARKET_DATA");
    },
  },
};
